export type ApplicationAndCustomerData = ApplicationData | CustomerData;

export interface ApplicationData {
  type: HyperlinkDataType.Application;
  application: Application;
}

export enum CustomerAccountType {
  Personal = 'PERSONAL',
  Business = 'BUSINESS',
}

export enum HyperlinkDataType {
  Customer = 'CUSTOMER',
  Application = 'APPLICATION',
}

export interface CustomerData {
  type: HyperlinkDataType.Customer;
  application: Application;
  customer: Customer;
}

export interface Application {
  application_id: string;
  account_type: string;
  name: {
    en: string | null;
    ar: string | null;
  };
  legal_name: {
    en: string | null;
    ar: string | null;
  };
  purpose_statement: {
    en: string | null;
    ar: string | null;
  };
  benefit_statement: {
    en: string | null;
    ar: string | null;
  };
  logo_url: string | null;
  sandbox: boolean;
}

export interface Customer {
  customer_id: string | null;
  account_type: string | null;
}

export interface HyperlinkState {
  error: string;
  fetchingTppData: boolean;
  fetchingBanks: boolean;
  isSubmitting: boolean;
  creatingCustomer: boolean;
  createCustomerError: string;
  data: ApplicationData | CustomerData;
  activeBanks: BankData[];
  disabledBanks: BankData[];
}

export interface HyperlinkError {
  message: string;
  errorCode: string;
}

type TransferLimit = {
  currency: string;
  min: number;
  max: number;
};

type BankAvailability = {
  payments: boolean;
  data: boolean;
};

export type BankData = {
  identifier: string;
  name: string;
  arabic_name: string | null;
  logo: string;
  logo_alt: string;
  main_color: string;
  background_color: string;
  theme: 'light' | 'dark';
  country_code: string;
  active: boolean;
  mock: boolean;
  bank_type: string;
  traits: string[];
  supported_account_types: string[];
  transfer_limits: TransferLimit[];
  international_transfer_limits: TransferLimit[];
  international_destinations: string[];
  account_type: string;
  supported_account_sub_types: string[];
  availability: {
    active: BankAvailability;
    enabled: BankAvailability;
  };
  is_active: boolean;
};

export type BankCategories = {
  activeBanks: BankData[];
  disabledBanks: BankData[];
};

export enum HyperlinkEnv {
  sa01 = 'sa',
  sa02 = 'sa02',
}
